const ecoSystem: string = process.env.REACT_APP_ECO_SYSTEM || "";


export const getProjectsSubscriptionTopic = (connectionId: string): string => {
  return `${ecoSystem}/connection/${connectionId}/service/hpd-dps/getProjects/reply`;
};

export const getProjectsRequestPublishTopic = (connectionId: string): string => {
  return `${ecoSystem}/connection/${connectionId}/service/hpd-dps/getProjects`;
};

export const getAccountsSubscriptionTopic = (connectionId: string): string => {
  return `${ecoSystem}/connection/${connectionId}/service/hpd-dps/getAccounts/reply`;
};

export const getAccountsRequestPublishTopic = (connectionId: string): string => {
  return `${ecoSystem}/connection/${connectionId}/service/hpd-dps/getAccounts`;
};

export const getWorkerTokenSubscriptionTopic = (connectionId: string): string => {
  return `${ecoSystem}/connection/${connectionId}/service/twilio/getWorkerToken/reply`;
};

export const getWorkerTokenRequestPublishTopic = (connectionId: string): string => {
  return `${ecoSystem}/connection/${connectionId}/service/twilio/getWorkerToken`;
};

export const getRespondersSubscriptionTopic = (connectionId: string): string => {
  return `${ecoSystem}/connection/${connectionId}/service/hpd-dps/getResponders/reply`;
};

export const getRespondersRequestPublishTopic = (connectionId: string): string => {
  return `${ecoSystem}/connection/${connectionId}/service/hpd-dps/getResponders`;
};

export const getCreateEventPageSubscriptionTopic = (connectionId: string): string => {
  return `${ecoSystem}/connection/${connectionId}/service/hpd-dps/createEventPage/reply`;
};

export const getCreateEventPagePublishTopic = (connectionId: string): string => {
  return `${ecoSystem}/connection/${connectionId}/service/hpd-dps/createEventPage`;
};

export const getCreateCustomPublishTopic = (connectionId: string): string => {
  return `${ecoSystem}/connection/${connectionId}/service/custom-bds/createCustom`;
};

export const getCreateCustomSubscriptionTopic = (connectionId: string): string => {
  return `${ecoSystem}/connection/${connectionId}/service/custom-bds/createCustom/reply`;
};

export const getSearchInCustomPublishTopic = (connectionId: string): string => {
  return `${ecoSystem}/connection/${connectionId}/service/custom-bds/searchInCustom`;
};

export const getSearchInCustomSubscriptionTopic = (connectionId: string): string => {
  return `${ecoSystem}/connection/${connectionId}/service/custom-bds/searchInCustom/reply`;
};

export const getUpdateCustomPublishTopic = (connectionId: string): string => {
  return `${ecoSystem}/connection/${connectionId}/service/custom-bds/updateCustom`;
};

export const getUpdateCustomSubscriptionTopic = (connectionId: string): string => {
  return `${ecoSystem}/connection/${connectionId}/service/custom-bds/updateCustom/reply`;
};

export const getCreateRidePagePublishTopic = (connectionId: string): string => {
  return `${ecoSystem}/connection/${connectionId}/service/ride-dps/createRideRequest`;
};

export const getCancelRidePagePublishTopic = (connectionId: string): string => {
  return `${ecoSystem}/connection/${connectionId}/service/ride-dps/cancelRideEvent`;
};

export const shareDispatchUrlPublishTopic = (connectionId: string): string => {
  return `${ecoSystem}/connection/${connectionId}/service/ride-dps/shareRideDispatchUrl`;
};

export const shareCalendarUrlPublishTopic = (connectionId: string): string => {
  return `${ecoSystem}/connection/${connectionId}/service/hpd-dps/shareCalendarUrl`;
};

export const getCancelRidePageSubscriptionTopic = (connectionId: string): string => {
  return `${ecoSystem}/connection/${connectionId}/service/ride-dps/cancelRideEvent/reply`;
};

export const getCreateRidePageSubscriptionTopic = (connectionId: string): string => {
  return `${ecoSystem}/connection/${connectionId}/service/ride-dps/createRideRequest/reply`;
};

export const getCreateTicketPagePublishTopic = (connectionId: string): string => {
  return `${ecoSystem}/connection/${connectionId}/service/hpd-dps/createTicketPage`;
};

export const getCreateTicketPageSubscriptionTopic = (connectionId: string): string => {
  return `${ecoSystem}/connection/${connectionId}/service/hpd-dps/createTicketPage/reply`;
};

export const getPageSubscriptionTopic = (connectionId: string): string => {
  return `${ecoSystem}/service/dps/service/live/searchInPage/reply`;
};

export const getPageRequestPublishTopic = (connectionId: string): string => {
  return `${ecoSystem}/service/dps/service/live/searchInPage`;
};

export const getPagesSubscriptionTopic = (connectionId: string): string => {
  return `${ecoSystem}/connection/${connectionId}/service/live/searchPage/reply`;
};

export const getPagesPublishTopic = (connectionId: string): string => {
  return `${ecoSystem}/connection/${connectionId}/service/live/searchPage`;
};


export const getAssetsSubscriptionTopic = (connectionId: string): string => {
  return `${ecoSystem}/connection/${connectionId}/service/hpd-dps/getAssets/reply`;
};

export const getAssetsRequestPublishTopic = (connectionId: string): string => {
  return `${ecoSystem}/connection/${connectionId}/service/hpd-dps/getAssets`;
};

export const getPageEotSubscriptionTopic = (pageId: string): string => {
  return `${ecoSystem}/service/live/page/${pageId}/bdsEot/#`;
};

export const getUsersSubscriptionTopic = (connectionId: string, cudbServiceId: string): string => {
  return `${ecoSystem}/connection/${connectionId}/service/${cudbServiceId}/searchUser/reply`;
};

export const getUserRequestPublishTopic = (connectionId: string, cudbServiceId: string): string => {
  return `${ecoSystem}/connection/${connectionId}/service/${cudbServiceId}/searchUser`;
};

export const getSearchMessageSubscriptionTopic = (pageId: string, connectionId: string): string=>{
  return `${process.env.REACT_APP_ECO_SYSTEM}/connection/${connectionId}/page/${pageId}/searchMessage/reply`;
}

export const getSearchMessagePublishTopic = (pageId: string, connectionId: string): string=> {
  return `${process.env.REACT_APP_ECO_SYSTEM}/connection/${connectionId}/page/${pageId}/searchMessage`;
}

export const getPageGroupMembersSubscriptionTopic = (pageId: string): string=> {
  return `${process.env.REACT_APP_ECO_SYSTEM}/service/live/page/${pageId}/group/members`;
}

export const getFocusMessagePublishTopic = (pageId: string, connectionId: string): string=> {
  return `${process.env.REACT_APP_ECO_SYSTEM}/connection/${connectionId}/page/${pageId}/focusMessage`;
}

export const getFocusPagePublishTopic = (pageId: string, userId: string): string=> {
  return `${process.env.REACT_APP_ECO_SYSTEM}/user/${userId}/page/${pageId}/focusPage`;
}

export const getFocusPageSubscriptionTopic = (userId: string): string=> {
  return `${process.env.REACT_APP_ECO_SYSTEM}/user/${userId}/page/+/focusPage`;
}

export const getAdminRolesTopic = (connectionId: string): string=> {
  return `${process.env.REACT_APP_ECO_SYSTEM}/connection/${connectionId}/service/dps/getAdminRoles/reply`;
}

export const getVehicleTypesTopic = (connectionId: string): string=> {
  return `${process.env.REACT_APP_ECO_SYSTEM}/connection/${connectionId}/service/dps/getVehicleTypes/reply`;
}

export const getAggregateBdsPublishTopic = (connectionId: string): string=> {
  return `${process.env.REACT_APP_ECO_SYSTEM}/connection/${connectionId}/service/bds/aggregateBds`;
}

export const getAggregateBdsSubscriptionTopic = (connectionId: string): string=> {
  return `${process.env.REACT_APP_ECO_SYSTEM}/connection/${connectionId}/service/bds/aggregateBds/reply`;
}

export const getRideEstimationPublishTopic = (connectionId: string): string=> {
  return `${process.env.REACT_APP_ECO_SYSTEM}/connection/${connectionId}/service/ride-dps/getRideEstimation`;
}

export const getFixedRatePublishTopic = (connectionId: string): string=> {
  return `${process.env.REACT_APP_ECO_SYSTEM}/connection/${connectionId}/service/ride-dps/getFixedRateByLocation`;
}

export const getBlockedAreaPublishTopic = (connectionId: string): string=> {
  return `${process.env.REACT_APP_ECO_SYSTEM}/connection/${connectionId}/service/ride-dps/getBlockedAreaByLocation`;
}

export const getVehiclesPublishTopic = (connectionId: string): string=> {
  return `${process.env.REACT_APP_ECO_SYSTEM}/connection/${connectionId}/service/ride-dps/getVehicleProjects`;
}

export const getVehiclesSubscriptionTopic = (connectionId: string): string=> {
  return `${process.env.REACT_APP_ECO_SYSTEM}/connection/${connectionId}/service/ride-dps/getVehicleProjects/reply`;
}

export const getRideEstimationSubscriptionTopic = (connectionId: string): string=> {
  return `${process.env.REACT_APP_ECO_SYSTEM}/connection/${connectionId}/service/ride-dps/getRideEstimation/reply`;
}

export const getFixedRateSubscriptionTopic = (connectionId: string): string=> {
  return `${process.env.REACT_APP_ECO_SYSTEM}/connection/${connectionId}/service/ride-dps/getFixedRateByLocation/reply`;
}

export const getBlockedAreaSubscriptionTopic = (connectionId: string): string=> {
  return `${process.env.REACT_APP_ECO_SYSTEM}/connection/${connectionId}/service/ride-dps/getBlockedAreaByLocation/reply`;
}

export const getTwilioUserStatusPublishTopic = (connectionId: string): string=> {
  return `${process.env.REACT_APP_ECO_SYSTEM}/connection/${connectionId}/service/twilio/getTwilioUserStatus`;
}

export const getTwilioUserStatusSubscriptionTopic = (connectionId: string): string=> {
  return `${process.env.REACT_APP_ECO_SYSTEM}/connection/${connectionId}/service/twilio/getTwilioUserStatus/reply`;
}

export const getTwilioUserSubscriptionTopic = (connectionId: string): string=> {
  return `${process.env.REACT_APP_ECO_SYSTEM}/connection/${connectionId}/service/twilio/getTwilioUser`;
}

export const getTwilioReservationCreatedSubscriptionTopic = (workerSid: string): string=> {
  return `${process.env.REACT_APP_ECO_SYSTEM}/service/+/user/${workerSid}/twilioReservationCreated`;
}

export const getTwilioReservationTimeoutSubscriptionTopic = (workerSid: string): string=> {
  return `${process.env.REACT_APP_ECO_SYSTEM}/service/+/user/${workerSid}/twilioReservationTimeout`;
}

export const getTwilioReservationCancelledSubscriptionTopic = (workerSid: string): string=> {
  return `${process.env.REACT_APP_ECO_SYSTEM}/service/+/user/${workerSid}/twilioReservationCancelled`;
}

export const getTwilioTaskCreatedSubscriptionTopic = (workerSid: string): string=> {
  return `${process.env.REACT_APP_ECO_SYSTEM}/service/+/user/${workerSid}/taskCreated/#`;
}

export const getTwilioRecordingSavedSubscriptionTopic = (workerSid: string): string=> {
  return `${process.env.REACT_APP_ECO_SYSTEM}/service/+/user/${workerSid}/twilioRecordingSaved`;
}

export const getTwilioAcceptReservationSubscriptionTopic = (callSid: string): string=> {
  return `${process.env.REACT_APP_ECO_SYSTEM}/service/twilio/service/workflow/acceptReservation/${callSid}`;
}

export const getTwilioRejectReservationSubscriptionTopic = (callSid: string): string=> {
  return `${process.env.REACT_APP_ECO_SYSTEM}/service/twilio/service/workflow/rejectReservation/${callSid}`;
}
export const getTwilioCompleteReservationSubscriptionTopic = (callSid: string): string=> {
  return `${process.env.REACT_APP_ECO_SYSTEM}/service/twilio/service/workflow/taskCompleted/${callSid}`;
}

export const getTwilioCompleteReservationWorkerSubscriptionTopic = (callSid: string, workerSid: string): string=> {
  return `${process.env.REACT_APP_ECO_SYSTEM}/service/twilio/user/${workerSid}/taskCompleted/${callSid}`;
}

export const callAcceptedPublishTopic = (workerSid: string): string=> {
  return `${process.env.REACT_APP_ECO_SYSTEM}/service/twilio/user/${workerSid}/callAccepted`;
}

export const getTwilioAddParticipantSubscriptionTopic = (connectionId: string): string=> {
  return `${process.env.REACT_APP_ECO_SYSTEM}/connection/${connectionId}/service/twilio/addParticipant`;
}

export const getTwilioRecordOutgoingSubscriptionTopic = (connectionId: string): string=> {
  return `${process.env.REACT_APP_ECO_SYSTEM}/connection/${connectionId}/service/twilio/recordOutgoingCall`;
}

export const getTwilioHoldCallSubscriptionTopic = (connectionId: string): string=> {
  return `${process.env.REACT_APP_ECO_SYSTEM}/connection/${connectionId}/service/twilio/holdCall`;
}

export const getTwilioCompleteCallSubscriptionTopic = (connectionId: string): string=> {
  return `${process.env.REACT_APP_ECO_SYSTEM}/connection/${connectionId}/service/twilio/completeCall`;
}


export const getEventUserStatusUpdatedSubscriptionTopic = (workerSid: string): string=> {
  return `${process.env.REACT_APP_ECO_SYSTEM}/service/+/user/${workerSid}/eventUserStatusUpdated`;
}

export const getTwilioTaskCancelledSubscriptionTopic = (workerSid: string): string=> {
  return `${process.env.REACT_APP_ECO_SYSTEM}/service/+/user/${workerSid}/taskCancelled/#`;
}

export const getTwilioTaskCompletedSubscriptionTopic = (workerSid: string): string=> {
  return `${process.env.REACT_APP_ECO_SYSTEM}/service/+/user/${workerSid}/taskCompleted/#`;
}

export const updateTwilioUserStatusPublishTopic = (connectionId: string): string=> {
  return `${process.env.REACT_APP_ECO_SYSTEM}/connection/${connectionId}/service/twilio/updateTwilioUserStatus`;
}

export const updateTwilioUserStatusSubscriptionTopic = (connectionId: string): string=> {
  return `${process.env.REACT_APP_ECO_SYSTEM}/connection/${connectionId}/service/twilio/updateTwilioUserStatus/reply`;
}

export const getBdsEotSubscriptionTopic = (cudbServiceId: string, userId: string): string=> {
  return `${process.env.REACT_APP_ECO_SYSTEM}/service/${cudbServiceId}/user/${userId}/bdsEot/#`;
}

export const getPageBdsEotSubscriptionTopic = (pageId: string): string=> {
  return `${process.env.REACT_APP_ECO_SYSTEM}/service/live/page/${pageId}/bdsEot/#`;
}

export const getPageAggregateBdsSubscriptionTopic = (connectionId: string): string=> {
  return `${process.env.REACT_APP_ECO_SYSTEM}/connection/${connectionId}/service/hpd-dps/getPageAggregateBds`;
}

export const getPageAggregateBdsPublishTopic = (connectionId: string): string=> {
  return `${process.env.REACT_APP_ECO_SYSTEM}/connection/${connectionId}/service/hpd-dps/getPageAggregateBds/reply`;
}

export const getMemberPageUpdatedPublishTopic = (memberId: string): string => {
  return `${process.env.REACT_APP_ECO_SYSTEM}/service/live/user/${memberId}/+`;
};

export const getRideInvitationSubscriptionTopic = (): string => {
  return `${process.env.REACT_APP_ECO_SYSTEM}/service/ride-dps/user/+/ridePageInvitation`;
};
